module.exports = __webpack_public_path__ + "static/img/theme2.a58d2e42.png";